export const getEmployeeID = (): string => {
  const queryParams = new URLSearchParams(window.location.search);
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
  return queryParams.get('id');
};

// @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
export const getLoggedInEmployeeID = () => window.merchantos.session.getEmployee().employeeID;

export const getIsValidEmployeeID = (employeeID: string | number) => Number(employeeID) > 0;
